module.exports = __webpack_public_path__ + "img/pause-alle.06d9624f.svg";